import React from 'react';
// import './index.scss';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

const propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    readOnly: PropTypes.bool,
    isRequired: PropTypes.bool,
};

const CheckBoxField = ({
    input,
    label,
    type,
    value,
    readOnly,
    onChange,
    meta: { touched, error, warning },
}) => {
    const { value: inputValue, onChange: inputOnChange } = input;

    const handleChange = (s) => {
        inputOnChange(s.target.checked);
        console.log(s.target.checked);
        if (onChange) {
            onChange(value);
        }
    };
    return (
        <>
            <Checkbox onChange={handleChange} checked={inputValue}>
                {label}
            </Checkbox>

            {touched &&
                ((error && (
                    <small className="text-danger text-validate">{error}</small>
                )) ||
                    (warning && (
                        <small className="text-warning text-validate">
                            {warning}
                        </small>
                    )))}
        </>
    );
};
CheckBoxField.propTypes = propTypes;

export default CheckBoxField;
